import React from 'react';

export default function Terms() {
    return (
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-lg-8">

                    <h1 className="mb-4 text-center">Terms of Service</h1>
                    {/*<p className="text-muted text-center">Last updated: August 21, 2025</p>*/}
                    <div className="mb-4">
                        <h2>1. Acceptance of Terms</h2>
                        <p>
                            By using the Nectr Studio website or services, you agree to these Terms of Service. If you disagree, please do not use our site.
                        </p>
                    </div>

                    <div className="mb-4">
                        <h2>2. Services</h2>
                        <p>
                            We provide website design and digital services for restaurants and bars. Details are subject to change.
                        </p>
                    </div>

                    <div className="mb-4">
                        <h2>3. Payment & Billing</h2>
                        <p>
                            All fees must be paid according to the terms agreed upon during onboarding. Late or missed payments may result in suspended services.
                        </p>
                    </div>

                    <div className="mb-4">
                        <h2>4. User Responsibilities</h2>
                        <p>
                            You agree to provide accurate content and feedback in a timely manner. You’re also responsible for complying with any applicable laws in your region.
                        </p>
                    </div>

                    <div className="mb-4">
                        <h2>5. Intellectual Property</h2>
                        <p>
                            Unless otherwise agreed, we retain the rights to our design, code, and underlying assets. Custom content provided by you remains yours.
                        </p>
                    </div>

                    <div className="mb-4">
                        <h2>6. Termination</h2>
                        <p>
                            Either party may terminate the agreement with written notice. Refunds (if any) are handled on a case-by-case basis.
                        </p>
                    </div>

                    <div className="mb-4">
                        <h2>7. Limitation of Liability</h2>
                        <p>
                            We are not liable for any indirect or incidental damages arising from your use of our services.
                        </p>
                    </div>

                    <div className="mb-4">
                        <h2>8. Updates</h2>
                        <p>
                            We may update these terms occasionally. Your continued use of our services means you accept the new terms.
                        </p>
                    </div>

                    <div className="mb-4">
                        <h2>9. Contact</h2>
                        <p>
                            For any questions, contact us at <a href="mailto:support@nectrstudio.com">support@nectrstudio.com</a>.
                        </p>
                    </div>

                </div>
            </div>
        </div>
    );
}
